module.exports = __webpack_public_path__ + "static/contact-background_2-3394ffa1275ddd68a8113f3f1b00f233.jpg";